import api from "./api.service";

export interface SesionUsuario {
  id: string;
  usuario_id: string;
  nombre: string;
  correo: string;
  rol: string;
  activo: boolean;
  session_activa: boolean;
  jti: string | null;
  ip: string | null;
  user_agent: string | null;
  created_at: string | null;
  expires_at: string | null;
  revoked_at: string | null;
  segundos_restantes: number;
}

export const getSesiones = async (): Promise<SesionUsuario[]> => {
  const resp = await api.get("/admin/sesiones");
  return resp.data;
};

export const forzarLogout = async (sesionId: string): Promise<void> => {
  await api.delete(`/admin/sesiones/${sesionId}`);
};

export const forzarLogoutTodos = async (): Promise<{ cantidad: number }> => {
  const resp = await api.delete("/admin/sesiones");
  return resp.data;
};
